import gql from 'graphql-tag';

const FRAGMENT_WORKSPACE = gql`
  fragment workspaceDetails on Workspace {
    id
    name
    mode
    workspaceUrl
    logo
    zipCode
    street
    city
    state
    countryId
    currency
  }
`;

export default {
  FRAGMENT_WORKSPACE,
};
